import React from 'react'
import styled from 'styled-components'
import { t } from 'i18next'
import { Col, Form, Row } from 'react-bootstrap'
import PickingIconPNG1 from '../../assets/icons/pick_notready.png'
import PickingIconPNG2 from '../../assets/icons/pick_partial.png'
import PickingIconPNG3 from '../../assets/icons/pick_ready.png'
import PickingIconPNG4 from '../../assets/icons/pick_printed.png'
import PickingIconPNG5 from '../../assets/icons/pick_ready_picked.png'
import PickingIconPNG6 from '../../assets/icons/pick_compl_shipped.png'
import PickingIconPNG7 from '../../assets/icons/pick_partial_picked.png'

const StyledWrapper = styled.div`


  .form-group {
    padding-left:20px;

    @media screen and (min-width: 460px) {
      width: auto;
    }
  }
`
export const PickingIcon1 = styled.span`
  background: url(${PickingIconPNG1}) center center no-repeat;
  background-size: contain;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
`
export const PickingIcon2 = styled.span`
  background: url(${PickingIconPNG2}) center center no-repeat;
  background-size: contain;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
`
export const PickingIcon3 = styled.span`
  background: url(${PickingIconPNG3}) center center no-repeat;
  background-size: contain;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
`
export const PickingIcon4 = styled.span`
  background: url(${PickingIconPNG4}) center center no-repeat;
  background-size: contain;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
`
export const PickingIcon5 = styled.span`
  background: url(${PickingIconPNG5}) center center no-repeat;
  background-size: contain;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
`
export const PickingIcon6 = styled.span`
  background: url(${PickingIconPNG6}) center center no-repeat;
  background-size: contain;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
`
export const PickingIcon7 = styled.span`
  background: url(${PickingIconPNG7}) center center no-repeat;
  background-size: contain;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
`

const StyledIconWrapper = styled.div`
    display: flex;
    width: 100%;
`
const PickingProcessFilter = ({ pickingProcessFilter, setPickingProcessFilter }) => {
    const showHasBeenPicked = true;
    return (
        <StyledWrapper>
            <Row>
                <Col>
                    <StyledIconWrapper>
                        <PickingIcon1 />
                        <Form.Check
                            type='checkbox'
                            id='includeNoPositionHasReservations'
                            name='includeNoPositionHasReservations'
                            label={t('withdrawalsTable:includeNoPositionHasReservations')}
                            checked={pickingProcessFilter.includeNoPositionHasReservations}
                            onChange={(e) => setPickingProcessFilter((prev) => ({
                                ...prev,
                                includeNoPositionHasReservations: e.target.checked,
                            }))}
                        />
                    </StyledIconWrapper>
                </Col>
            </Row>
            <Row>
                <Col>
                    <StyledIconWrapper>
                        <PickingIcon2 />
                        <Form.Check
                            type='checkbox'
                            id='includePartiallyReserved'
                            name='includePartiallyReserved'
                            label={t('withdrawalsTable:includePartiallyReserved')}
                            checked={pickingProcessFilter.includePartiallyReserved}
                            onChange={(e) => setPickingProcessFilter((prev) => ({
                                ...prev,
                                includePartiallyReserved: e.target.checked,
                            }))}
                        />
                    </StyledIconWrapper>
                </Col>
            </Row>
            <Row>
                <Col>
                    <StyledIconWrapper>
                        <PickingIcon3 />
                        <Form.Check
                            type='checkbox'
                            id='includeReadyForShipment'
                            name='includeReadyForShipment'
                            label={t('withdrawalsTable:includeReadyForShipment')}
                            checked={pickingProcessFilter.includeReadyForShipment}
                            onChange={(e) => setPickingProcessFilter((prev) => ({
                                ...prev,
                                includeReadyForShipment: e.target.checked,
                            }))}
                        />
                    </StyledIconWrapper>
                </Col>
            </Row>
            <Row>
                <Col>
                    <StyledIconWrapper>
                        <PickingIcon4 />
                        <Form.Check
                            type='checkbox'
                            id='includePickingProcessStarted'
                            name='includePickingProcessStarted'
                            label={t('withdrawalsTable:includePickingProcessStarted')}
                            checked={pickingProcessFilter.includePickingProcessStarted}
                            onChange={(e) => setPickingProcessFilter((prev) => ({
                                ...prev,
                                includePickingProcessStarted: e.target.checked,
                            }))}
                        />
                    </StyledIconWrapper>
                </Col>
            </Row>
            <Row>
                <Col>
                    <StyledIconWrapper>
                        <PickingIcon7 />
                        <Form.Check
                            type='checkbox'
                            id='includePartialPicked'
                            name='includePartialPicked'
                            label={t('withdrawalsTable:includePartialPicked')}
                            checked={pickingProcessFilter.includePartialPicked}
                            onChange={(e) => setPickingProcessFilter((prev) => ({
                                ...prev,
                                includePartialPicked: e.target.checked,
                            }))}
                        />
                    </StyledIconWrapper>
                </Col>
            </Row>
            {showHasBeenPicked && <Row>
                <Col>
                    <StyledIconWrapper>
                        <PickingIcon5 />
                        <Form.Check
                            type='checkbox'
                            id='includeHasBeenPicked'
                            name='includeHasBeenPicked'
                            label={t('withdrawalsTable:includeHasBeenPicked')}
                            checked={pickingProcessFilter.includeHasBeenPicked}
                            onChange={(e) => setPickingProcessFilter((prev) => ({
                                ...prev,
                                includeHasBeenPicked: e.target.checked,
                            }))}
                        />
                    </StyledIconWrapper>
                </Col>
            </Row>}
            <Row>
                <Col>
                    <StyledIconWrapper>
                        <PickingIcon6 />
                        <Form.Check
                            type='checkbox'
                            id='includeIsCompletyShipped'
                            name='includeIsCompletyShipped'
                            label={t('withdrawalsTable:includeIsCompletyShipped')}
                            checked={pickingProcessFilter.includeIsCompletyShipped}
                            onChange={(e) => setPickingProcessFilter((prev) => ({
                                ...prev,
                                includeIsCompletyShipped: e.target.checked,
                            }))}
                        />
                    </StyledIconWrapper>
                </Col>
            </Row>
        </StyledWrapper>
    )
}
export default PickingProcessFilter